<div class="flags flags-invoice">
  <div *ngFor="let tag of tags" class="tag-container">
    <div class="tag invoice-tag">{{tag}}</div>
  </div>
</div>
